import { servicesWithdraws as services } from 'services';
import { TAsyncStatesHandlers } from 'hooks/use-mutation-hook-wrapper';
import { withdraws as types, network } from 'types';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';

const useGetWithdraws = (
    arg0?: TAsyncStatesHandlers<
        network.TQueryDefWrapper<types.TWithdraws[]>,
        string
    >,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<types.TWithdraws[]>,
        string,
        null
    >({
        queryKey: 'withdraws',
        queryFn: services.get,
        queryConfig: arg0,
        values: null,
    });
};

export default useGetWithdraws;
